import React from 'react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

interface RegisteredAddressInputProps {
  value?: string | null;
  onChange: (value: string) => void;
  disabled: boolean;
}

export default function RegisteredAddressInput({
  value,
  onChange,
  disabled,
}: RegisteredAddressInputProps) {
  const { t } = useTranslation();

  return (
    <TextField
      label={t('formInputs.registeredAddressInputLabel')}
      variant='outlined'
      fullWidth
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    />
  );
}
